import Origin, { configureOriginClasses } from "components/organisms/editor/core/model/lib/origin/base";
import RestoreOrigin from "components/organisms/editor/core/model/lib/origin/restore_origin";
import RestoreFileOrigin from "components/organisms/editor/core/model/lib/origin/restore_file_origin";
import RestoreProjectOrigin from "components/organisms/editor/core/model/lib/origin/restore_project_origin";

configureOriginClasses({
    RestoreOrigin,
    RestoreFileOrigin,
    RestoreProjectOrigin,
});

export default Origin;
